import useApi from "./useApi";

export const useAdminApi = () => {
  const { api, callApi, loading, error } = useApi({ showToast: true });

  // Dashboard stats
  const getStats = () =>
    api.get("/admin/v1/stats", {}, { showToast: false });

  // Users list
  const getUsers = (params = {}) =>
    api.get("/admin/v1/users", params, { showToast: false });

  // Subscriptions — per-user subscription status for dashboard
  const getSubscriptions = (params = {}) =>
    api.get("/admin/v1/subscriptions", { is_active: true, ...params }, { showToast: false });

  // Doctors — write operations only (reads via existing useDoctorsApi)
  const createDoctor = (body) => api.post("/doctors/v1/doctors", body);
  const updateDoctor = (id, body) => api.put(`/doctors/v1/doctors/${id}`, body);
  const deleteDoctor = (id) => api.delete(`/doctors/v1/doctors/${id}`);

  // Clinics CRUD
  const getClinics = (params = {}) =>
    api.get("/doctors/v1/clinics", params, { showToast: false });
  const createClinic = (body) => api.post("/doctors/v1/clinics", body);
  const updateClinic = (id, body) => api.put(`/doctors/v1/clinics/${id}`, body);

  // Availability
  const getDoctorAvailability = (doctorId) =>
    api.get(`/doctors/v1/doctors/${doctorId}/availability`, {}, { showToast: false });
  const updateDoctorAvailability = (doctorId, body) =>
    api.put(`/doctors/v1/doctors/${doctorId}/availability`, body);

  // Resolve a Google Maps URL (short or long) to { lat, lon }
  const resolveMapsUrl = (url) =>
    api.get("/doctors/v1/maps/resolve", { url }, { showToast: false });

  // Photo upload — multipart/form-data (let axios set boundary automatically)
  const uploadDoctorPhoto = (doctorId, formData) =>
    callApi(`/doctors/v1/doctors/${doctorId}/photo`, {
      method: "POST",
      body: formData,
      headers: { "Content-Type": undefined },
    });

  // Verify a single user subscription by user_id or subscription_id
  const verifySubscription = (id) =>
    api.get("/subscription/v1/api/verify", { id }, { showToast: false });

  return {
    getStats,
    getUsers,
    getSubscriptions,
    verifySubscription,
    createDoctor,
    updateDoctor,
    deleteDoctor,
    getClinics,
    createClinic,
    updateClinic,
    getDoctorAvailability,
    updateDoctorAvailability,
    uploadDoctorPhoto,
    resolveMapsUrl,
    loading,
    error,
  };
};

export default useAdminApi;
